<template>
  <div>
    <el-dialog title="订单原料分配" :visible.sync="visible" width="1070px" @close="close" :close-on-click-modal="false">
      <div>
        <div>
          <span class="title">机组：</span>
          <el-select clearable style="max-width: 180px" @change="loadList" filterable v-model="schedulingFactoryModelId"
            size="small" maxlength="16" placeholder="机组">
            <el-option v-for="item in workershopList" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
          <span class="title" style="margin-left:40px">规格：</span>
          <el-input v-model="specificationTop" placeholder="请输入" size="small" style="width:200px" clearable
            @change="loadList"></el-input>

          <span style="margin-left:40px">订单完成时间：</span>
          <el-date-picker v-model="dateRange" type="daterange" size="small" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" @change="dateChange">
          </el-date-picker>

        </div>
        <div class="main">
          <div class="right">
            <div style="height: 100%">
              <div class="thead">
                <div style="width: 110px">订单号</div>
                <div style="width: 160px">物料名称</div>
                <div style="width: 100px">规格</div>
                <div style="width: 60px">订单教量</div>
                <div style="width: 60px">件数</div>
                <div style="width: 140px">订单母卷完成时间</div>
              </div>

              <div class="content">
                <div v-for="(g, index) in group" :key="index" class="list-groupR" group="task">
                  <div class="tbody">
                    <div v-for="task in g.item" :key="task.productionBatchCode" class="tr">
                      <div style="width: 110px">
                        {{ task.productionBatchCode }}
                      </div>
                      <div style="width: 160px">
                        {{ task.materialName }}
                      </div>
                      <div style="width: 100px">{{ task.specification }}</div>
                      <div style="width: 60px">{{ task.splitCount }}</div>
                      <div style="width: 60px">{{ task.auxQty }}</div>
                      <div style="width: 140px">{{ task.subFinishTime }}</div>
                    </div>
                  </div>
                  <div class="configPanel">
                    <div v-for="item in g.material" :key="item.seqNo">
                      <el-tooltip v-if="item.configType == 1" effect="dark" :content="item.materialName"
                        placement="top-start" :disabled="!item.materialName">
                        <el-badge :value="item.materialName ? item.materialName.split('、').length : 0"
                          :hidden="!item.materialName">
                          <el-button plain type="primary" size="mini" @click="showMaterialDialog(item)">{{
                            item.configName }}</el-button>
                        </el-badge>
                      </el-tooltip>

                      <el-input v-if="item.configType == 0" style="width:140px" size="mini"
                        v-model="item.consumeDuration" :placeholder="item.configName" clearable @change=""></el-input>
                    </div>
                    <div>
                      <el-button style="width:60px" type="primary" size="mini" @click="submitConfig(g)">保存</el-button>
                    </div>

                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <!-- <span slot="footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="submint">确 定</el-button>
      </span> -->
      <el-dialog title="原料选择" :visible.sync="materialDialog" :close-on-click-modal="false" append-to-body width="800px"
        @close="">
        <div class="dialogContent">
          <div class="choosedPanel">
            <h3>已选择原料</h3>
            <div style="background:#EBF9FF;line-height:30px;font-size:15px;font-weight:600;margin:10px 0">原料名称</div>
            <div style="height:300px;overflow:auto">
              <div v-for="(item, index) in choosedMaterial" :key="item.materialId">
                <el-tooltip effect="dark" :content="item.materialName" placement="top-start">
                  <p>{{ item.materialName }}</p>
                </el-tooltip>
                <i class="el-icon-delete" style="color:red;cursor: pointer;"
                  @click="choosedMaterial.splice(index, 1)"></i>
              </div>
            </div>
          </div>
          <div class="line"></div>
          <div style="width:500px;padding:0 30px">
            <h3>选择原料</h3>
            <div class="searchline">
              <span>原料名称：</span>
              <el-input style="width:100px" v-model="materialName" placeholder="请输入" size="small" clearable></el-input>
              <span style="margin-left:20px">规格：</span>
              <el-input style="width:100px" v-model="specification" placeholder="请输入" size="small" clearable></el-input>
              <el-button style="margin-left:86px" type="primary" size="mini" @click="getMaterialList">查询</el-button>
            </div>
            <el-table :data="materialList" stripe max-height="300px">
              <el-table-column label="原料名称" prop="materialName"></el-table-column>
              <el-table-column label="原料规格" prop="specification"></el-table-column>
              <el-table-column label="" width="60px">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="addMaterial(scope.row)">添加</el-button>

                </template>
              </el-table-column>
            </el-table>

          </div>
        </div>
        <span slot="footer">
          <el-button @click="materialDialog = false">取消</el-button>
          <el-button type="primary" @click="saveMaterial">确定</el-button>
        </span>
      </el-dialog>

    </el-dialog>
  </div>
</template>

<script>
import { add, format } from "date-fns";
export default {
  name: "materialConfigDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    workershopList: {
      type: Array,
      default: () => [],
    },
    productionStateOption: {
      type: Array,
      default: () => [],
    },
  },
  components: {
  },
  data() {
    return {
      materialDialog: false,
      dateRange: [new Date((new Date().getTime() - 1000 * 3600 * 24 * 7)), new Date()],
      specificationTop: '',
      schedulingFactoryModelId: "",
      group: [],
      currentPip: null,
      choosedMaterial: [],
      materialName: '',
      specification: '',
      materialList: []
    };
  },
  watch: {
    visible(newValue) {
      if (newValue) {
        if (this.workershopList[0]) {
          this.schedulingFactoryModelId = this.workershopList[0].id;
          this.loadList();
        } else {
          this.$message.error("无机组数据");
        }
      }
    },
  },
  mounted() { },
  methods: {
    getMaterialList() {
      this.$RequestUtil.get({
        url: "/api/production-cost/material",
        params: {
          materialName: this.materialName,
          specification: this.specification
        },
        success: (res) => {
          if (res.code == 0) {
            this.materialList = res.data;
          }
        },
      });
    },
    addMaterial(row) {
      console.log(this.choosedMaterial.findIndex(o => o.materialId == row.materialId))
      if (this.choosedMaterial.findIndex(o => o.materialId == row.materialId) == -1) {
        this.choosedMaterial.push(row)
      } else {
        this.$message.warning("已存在")
      }
    },
    saveMaterial() {
      // const group = this.group.find(e=>e.groupId == this.currentPip.groupId)
      // const materialConfig = group.material.find(e=>e.configId == this.currentPip.configId)
      const materialNameArr = [];
      const materialArr = [];
      this.choosedMaterial.forEach(e => {
        materialNameArr.push(e.materialName);
        materialArr.push(e.materialId);
      })
      this.currentPip.materialName = materialNameArr.join("、");
      this.currentPip.material = materialArr.join("、");
      this.materialDialog = false;
    },
    dateChange(dateRange) {

      this.getMaterialConfigList()
    },
    loadList() {
      if (this.schedulingFactoryModelId) {
        this.getMaterialConfigList();
      }
    },


    getMaterialConfigList() {
      this.$RequestUtil.post({
        url: "/api/production-cost/list-config",
        params: {
          "factoryModelId": this.schedulingFactoryModelId,
          "pageNum": 0,
          "pageSize": 10000,
          "startDate": this.dateRange[0],
          "specification": this.specificationTop,
          "endDate": add(this.dateRange[1], { days: 1 }),
        },
        success: (res) => {
          if (res.code == 0) {
            this.group = res.data;
          }
        },
      });
    },

    showMaterialDialog(item) {
      this.currentPip = item;
      if (item.materialName) {
        const materialNameArr = item.materialName.split("、");
        const materialArr = item.material.split("、");
        this.choosedMaterial = materialNameArr.map((e, index) => {
          return {
            materialId: materialArr[index],
            materialName: e
          }
        })
      } else {
        this.choosedMaterial = []
      }

      this.getMaterialList()
      this.materialDialog = true;
    },

    submitConfig(group) {
      let falg = false
      group.material.forEach(e => {
        e.factoryModelId = this.schedulingFactoryModelId
        if (e.configType == 0) {
          if (!/^\d*\.?\d{1,2}$/.test(e.consumeDuration)) {
            falg = true
          }
        }
      })
      if (falg) {
        this.$message.error("亲水料管必须为数字，最多两位小数")
        return
      }
      this.$RequestUtil.post({
        url: "/api/production-cost/config-submit",
        params: {
          groupId: group.groupId,
          material: group.material
        },
        success: (res) => {
          if (res.code == 0) {
            this.$message({ type: "success", message: "操作成功" });
          }
        },
      });
    },
    close() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style scoped>
.searchline {
  margin: 10px 0;
}

.dialogContent {
  display: flex;
  height: 400px;
  text-align: center;
}

.choosedPanel {
  width: 200px;
}

.choosedPanel p {
  width: 110px;
  overflow: hidden;
  text-wrap: nowrap;
  margin-left: 20px;
  line-height: 30px;
  display: inline-flex;
}

.line {
  height: 100%;
  border: 1px solid #ccc;
}

.main {
  display: flex;
}

.main>div {
  border: 1px solid #ccc;
  margin: 20px;
}

.list-groupR {
  margin: 10px 30px;
  display: flex;
}

.tbody {
  width: 800px;
  height: 120px;
  border: 1px solid #ccc;
  border-radius: 8px;
  overflow: auto;
}

.content {
  height: 380px;
  overflow: auto;
}

.configPanel {
  width: 300px;
  display: flex;
  flex-wrap: wrap;
  margin-left: 40px;
}

.configPanel>div {
  margin-right: 20px;
}

.configPanel .el-button {
  width: 100px;
}

.addGroup {
  position: absolute;
  left: -20px;
  color: #66b1ff;
  /* right: -20px; */
  top: 20px;
  cursor: pointer;
}

.thead {
  display: flex;
  padding-left: 30px;
  text-align: center;
}

.tr {
  display: flex;
  text-align: center;
  line-height: 20px;

}

.right {
  width: 1000px;
  height: 400px;
}

.right th {
  width: 90px;
  text-align: center;
}

.right td {
  width: 90px;
  text-align: center;
}



.right table {
  display: block;
  overflow: auto;
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/order/ProductionTask/MaterialConfigDialog.vue